<template>
  <el-form
    style="margin-top: 16px"
    :model="field"
    :rules="rules"
    ref="form"
    label-width="140px"
  >
    <el-form-item
      v-if="nameEnabled"
      label="Name"
      prop="name.singular"
    >
      <el-input
        v-model="field.name.singular"
        v-on:input="onNameChange()"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="namePluralEnabled"
      label="Name Plural"
      prop="name.plural"
    >
      <el-input v-model="field.name.plural"></el-input>
    </el-form-item>
    <el-form-item
      v-if="labelEnabled"
      label="Label"
      prop="label.singular"
    >
      <el-input v-model="field.label.singular"></el-input>
    </el-form-item>

    <el-form-item
      v-if="labelPluralEnabled"
      label="Label Plural"
      prop="label.plural"
    >
      <el-input v-model="field.label.plural"></el-input>
    </el-form-item>

    <el-form-item label="Type" prop="type">
      <el-select
        v-model="field.type"
        placeholder="Please select one option"
        v-on:change="
          setupPropertiesRelationAndValidations()
        "
      >
        <el-option
          v-for="choice in typeChoices"
          :key="choice.value"
          :label="choice.label"
          :value="choice.value"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import variableNamePattern from '../../util/variable-name-regex';
import NameLabelNormalizer from '../name-label-normalizer';

const buildRules = (store) => {
  const nameRequired =
    store.getters['builder/fieldName/required'];
  const namePluralRequired =
    store.getters['builder/fieldNamePlural/required'];
  const labelRequired =
    store.getters['builder/fieldLabel/required'];
  const labelPluralRequired =
    store.getters['builder/fieldLabelPlural/required'];
  const typeRequired =
    store.getters['builder/fieldType/required'];

  const rules = {};

  if (nameRequired) {
    rules['name.singular'] = [
      {
        required: true,
        message: 'Name is required',
        trigger: 'blur',
      },
      {
        pattern: /^[_a-zA-Z][_a-zA-Z0-9]*$/,
        message: 'Name is not a valid variable name',
        trigger: 'blur',
      },
      {
        pattern: variableNamePattern,
        message: 'Name is not a valid variable name',
        trigger: 'blur',
      },
    ];
  }

  if (namePluralRequired) {
    rules['name.plural'] = [
      {
        required: true,
        message: 'Name Plural is required',
        trigger: 'blur',
      },
      {
        pattern: /^[_a-zA-Z][_a-zA-Z0-9]*$/,
        message: 'Name Plural is not a valid variable name',
        trigger: 'blur',
      },
      {
        pattern: variableNamePattern,
        message: 'Name Plural is not a valid variable name',
        trigger: 'blur',
      },
    ];
  }

  if (labelRequired) {
    rules['label.singular'] = [
      {
        required: true,
        message: 'Label is required',
        trigger: 'blur',
      },
    ];
  }

  if (labelPluralRequired) {
    rules['label.plural'] = [
      {
        required: true,
        message: 'Label Plural is required',
        trigger: 'blur',
      },
    ];
  }

  if (typeRequired) {
    rules.type = [
      {
        required: true,
        message: 'Type is required',
        trigger: 'blur',
      },
    ];
  }

  return rules;
};

export default {
  name: 'app-field-form-basic',

  data() {
    return {
      rules: buildRules(this.$store),
    };
  },

  mounted() {
    if (
      this.$refs.tooltip1 &&
      this.$refs.tooltip1.referenceElm
    ) {
      this.$refs.tooltip1.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    if (
      this.$refs.tooltip2 &&
      this.$refs.tooltip2.referenceElm
    ) {
      this.$refs.tooltip2.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    if (
      this.$refs.tooltip3 &&
      this.$refs.tooltip3.referenceElm
    ) {
      this.$refs.tooltip3.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    if (
      this.$refs.tooltip4 &&
      this.$refs.tooltip4.referenceElm
    ) {
      this.$refs.tooltip4.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    this.$store.commit(
      'builder/fieldCurrent/basicForm',
      this.$refs.form,
    );
  },

  computed: {
    ...mapGetters({
      field: 'builder/fieldCurrent/current',
      nameEnabled: 'builder/fieldName/enabled',
      namePluralEnabled: 'builder/fieldNamePlural/enabled',
      labelEnabled: 'builder/fieldLabel/enabled',
      labelPluralEnabled:
        'builder/fieldLabelPlural/enabled',
      typeChoices: 'builder/fieldType/choices',
    }),
  },

  methods: {
    ...mapActions({
      setupPropertiesRelationAndValidations:
        'builder/fieldCurrent/setupPropertiesRelationAndValidations',
    }),

    onNameChange() {
      const nameSingular = this.field.name.singular;

      if (this.namePluralEnabled) {
        this.field.name.plural = NameLabelNormalizer.createPlural(
          nameSingular,
        );
      }

      if (this.labelEnabled) {
        this.field.label.singular = NameLabelNormalizer.createLabel(
          nameSingular,
        );
      }

      if (this.labelPluralEnabled) {
        this.field.label.plural = NameLabelNormalizer.createLabelPlural(
          nameSingular,
        );
      }
    },
  },
};
</script>

<style></style>
